import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import {
  Breadcrumbs as TPABreadcrumbs,
  BreadcrumbsItem,
} from 'wix-ui-tpa/cssVars';

import { BreadcrumbsItemId, DataHooks } from './consts';
import { classes, st } from './Breadcrumbs.st.css';
import { BreadcrumbsViewModel } from '../../../../../viewModel/viewModel';

export interface BreadcrumbsProps {
  breadcrumbsViewModel: BreadcrumbsViewModel;
}

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ breadcrumbsViewModel }) => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();
  const homeLabel = t('app.breadcrumbs.home.label');
  const serviceListLabel = t('app.breadcrumbs.service-list.label');
  const { homeUrl } = breadcrumbsViewModel;

  const items: BreadcrumbsItem[] = [
    { id: BreadcrumbsItemId.HOME, value: homeLabel, href: homeUrl },
    {
      id: BreadcrumbsItemId.SERVICE_LIST,
      value: serviceListLabel,
      href: '',
    },
  ];

  return (
    <TPABreadcrumbs
      items={items}
      showTrailOnMobileMode={true}
      data-hook={DataHooks.ROOT}
      className={st(classes.root, { isMobile })}
    />
  );
};
